

































































import { Vue, Component, Prop,Watch } from 'vue-property-decorator';
import AMSformTable from '@/components/AMSformTable.vue';
import AMSTable from '@/components/AMSTable.vue';
import AMSProductImg from '@/components/AMSProductImg.vue';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import request from '@/utils/request';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import { AppStore } from '@/store/modules/app';
import { exportStockDetail } from '@/api/stock'
import moment from 'moment';
interface Form {
  productName?: string;
  productCategoryId?: string;
  brandId?: string;
  number?: string;
  stockCategory?: string;
  stockTimeStart?: String;
  stockTimeEnd?: String;
  productId?: string;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-product': AMSProduct,
    'ams-brand-selector': AMSBrandSelector,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class StockDetail extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: 'stockDetail'
    },
    {
      text: '出入库明细',
      disabled: true
    }
  ];
  lastTime = '';
  startTime = '';
  api: string = '/api/Stock/Products/List';
  form: Form = {};
  initForm() {
    this.form = {
      brandId: '',
      stockCategory: '',
      productId: ''
    };
    this.lastTime =''
    this.startTime =''
    this.displayCate = ''
    this.displayBrand = {}
  }
  beforeQuery() {
    delete this.form.productId;
  }
  rules = {
    number: [],
    name: []
  };
  categoryList: Array<any> = [];
  statusList = [{ text: '全部', value: '' }, { text: '入库', value: 'In' }, { text: '出库', value: 'Out' }];
  BeginTime: boolean = false;
  EndTime: boolean = false;
  date: string = new Date().toISOString().substr(0, 10);
  headers: Array<any> = [
    {
      text: '商品',
      value: 'name',
      sortable: false,
      render: (h: Function, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row,
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true
          }
        });
      },
      width: 160,
      align: 'left'
    },
    { text: '容量', value: 'capacity', sortable: false, width: 100, align: 'left' },
    { text: '单据号', value: 'stockNumber', sortable: false, width: 160, align: 'left' },
    {
      text: '类型',
      value: 'stockCategory',
      sortable: false,
      render: (h: Function, param: any) => {
        return h('div', this.switchType(param.row[param.keyName]));
      },
      width: 100,
      align: 'left'
    },
    { text: '数量', 
      value: 'quantity', 
      sortable: false, 
      width: 80, 
      align: 'right',
      render: (h: any, param: any) => {
        return h('div', this.renderAmount(param));
      }
    },
    { text: '经办人', value: 'operator', sortable: false, width: 150, align: 'left' },
    { text: '时间', value: 'stockTime', isFormatDate: true, sortable: false, width: 150, align: 'left' }
  ];
  displayCate: string = '';
  displayBrand: any = {};

  onStockCategoryClear(){
    setTimeout(() => {
      this.form.stockCategory = '';
    }, 1);
  }
  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as any).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as any).blur();
  }
 @Watch('lastTime', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.stockTimeEnd = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTime', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.stockTimeStart = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('BeginTime', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('EndTime', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  created() {
    this.initForm();
    let param: any = this.$route.params;
    if (param.item) {
      this.form.productName = param.item.name;
    }
    if (param.name) {
      this.form.productName = param.name;
    }
    this.form.productId = this.$route.query.id ? this.$route.query.id.toString() : '';
  }

  switchType(stockCategory: string) {
    switch (stockCategory) {
      case 'In':
        return '入库';
      case 'Out':
        return '出库';
    }
  }

  renderAmount(param: any) {
    return param.row.stockCategory == 'Out' ? ('-' + param.row[param.keyName]) : ('+' + param.row[param.keyName]);
  }

  handleExport() {
    const params = Object.assign({}, { 
      ...this.form,
      brandId: this.displayBrand.id || '',
      productCategoryName: this.displayCate,
      brandName: this.displayBrand.name || '',
      exportExcel: true 
    });
    exportStockDetail(params)
      .then(response => {
        AppStore.ShowSuccess('下载成功');
      })
      .catch(error => {
        AppStore.ShowError('下载失败');
      });
  }
  getCateName(id: string, displayName: string) {
    this.displayCate = displayName || ''
  }
  getBrand(item: any) {
    this.displayBrand = item
  }
}
